var _g, _g2, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIFilePdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 45,
    viewBox: "0 0 40 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2435_61346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.48715 36.8457V7.28125H6.20312V40.1297H30.9201V36.8457H9.48715Z",
    fill: "#F4F6FA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2435_61346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.48438 4V36.8485H34.2014V11.5193L26.6821 4H9.48438Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.199 11.5193L26.6797 4V11.5193H34.199Z",
    fill: "#F4F6FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1428 19.006H17.9089C18.2416 19.006 18.5319 19.0726 18.7738 19.1996C19.0158 19.3266 19.2033 19.5081 19.3242 19.7319C19.4452 19.9556 19.5117 20.2218 19.5117 20.5242C19.5117 20.8266 19.4452 21.0867 19.3182 21.3165C19.1912 21.5464 19.0037 21.7218 18.7557 21.8488C18.5077 21.9758 18.2174 22.0363 17.8787 22.0363H17.0682V23.5H16.1367V19L16.1428 19.006ZM17.7335 21.2863C18.0057 21.2863 18.2053 21.2198 18.3444 21.0806C18.4835 20.9415 18.55 20.754 18.55 20.5242C18.55 20.2944 18.4835 20.1069 18.3444 19.9738C18.2053 19.8407 17.9996 19.7742 17.7335 19.7742H17.0742V21.2923H17.7335V21.2863Z",
    fill: "#82868C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1133 23.5V19H21.7161C22.1637 19 22.5568 19.0907 22.8834 19.2661C23.2101 19.4415 23.4641 19.7016 23.6395 20.0403C23.8149 20.379 23.8996 20.7782 23.8996 21.2379C23.8996 21.6976 23.8088 22.1089 23.6334 22.4476C23.458 22.7863 23.204 23.0464 22.8774 23.2278C22.5508 23.4093 22.1576 23.5 21.698 23.5H20.1133ZM21.6617 22.6956C22.0972 22.6956 22.4238 22.5746 22.6415 22.3387C22.8592 22.1028 22.9681 21.7339 22.9681 21.2379C22.9681 20.7419 22.8592 20.379 22.6415 20.1492C22.4238 19.9194 22.1032 19.7984 21.6677 19.7984H21.0447V22.6956H21.6617Z",
    fill: "#82868C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5703 19.006H27.534V19.7742H25.5018V20.869H27.3405V21.6371H25.5018V23.5H24.5703V19V19.006Z",
    fill: "#82868C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2435_61346",
    x: 2.20312,
    y: 3.28125,
    width: 32.7188,
    height: 40.8516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2435_61346"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2435_61346",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2435_61346",
    x: 5.48438,
    y: 0,
    width: 32.7188,
    height: 40.8516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2435_61346"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2435_61346",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIFilePdf);
export default __webpack_public_path__ + "static/media/i_file_pdf.8792bf3bb0adce1ef224a70d3c2f189e.svg";
export { ForwardRef as ReactComponent };